common.View.create('shop::productVariant.createEdit.Graduate', {

    onDOMLoad() {
        this.initFilterInputs();
    },

    initFilterInputs() {
        // Find search field
        $(document).on('keyup', '.crud\\:\\:form-dataset-table-Item td[class] input', (event) => {
            // No valid value given?
            if( !$(event.currentTarget).val() ) {
                $(event.currentTarget).parents('.crud\\:\\:form-dataset-table-Item')
                    .find('.price input, .percentage input')
                        .attr('disabled', false);

                return;
            }

            $(event.currentTarget).parents('.crud\\:\\:form-dataset-table-Item')
                .find('.price input, .percentage input')
                    .not(event.currentTarget)
                    .attr('disabled', true);
        });

        $('.crud\\:\\:form-dataset-table-Item td[class] input').trigger('keyup');
    }

});
